<template>
    <div>
        <div id='section'>
        <div v-if="configBasicInfo()" class='section-title'>{{ $t('teamInfo.basicInfo') }}</div>
            <div v-if="teamInfo.city"><span>{{ $t("teamInfo.city") }}</span><span v-html="teamInfo.city"></span></div>
            <hr v-if="teamInfo.city"/>
            <div v-if="teamInfo.homeCourt"><span>{{ $t("teamInfo.homeCourt") }}</span><span v-html="teamInfo.homeCourt"></span></div>
            <hr v-if="teamInfo.homeCourt"/>
            <div v-if="teamInfo.capacity"><span>{{ $t("teamInfo.capacity") }}</span><span v-html="teamInfo.capacity"></span></div>
            <hr v-if="teamInfo.capacity"/>
            <div v-if="teamInfo.address"><span>{{ $t("teamInfo.address") }}</span><span v-html="teamInfo.address"></span></div>
        </div>
        <div v-if="teamInfo.honour" class='section-title'>{{ $t("teamInfo.honour") }}</div>
        <div v-if="teamInfo.honour" class="honour" v-html="teamInfo.honour"></div>
        <div v-if="teamInfo.summary" class='section-title'>{{ $t("teamInfo.summary") }}</div>
        <div v-if="teamInfo.summary" class="summary" v-html="teamInfo.summary"></div>
        <loadStateView :state='hasData ? 0 : 3'/>
    </div>
</template>

<script>
export default {
  props: {
    teamInfoForRoute: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mounted () {
    if (this.$route.params.teamInfoForRoute && this.$route.params.teamInfoForRoute.coachName) {
      this.teamInfo = this.$route.params.teamInfoForRoute
    }
  },
  activated () {
    if (this.$route.params.teamInfoForRoute && this.$route.params.teamInfoForRoute.coachName) {
      this.teamInfo = this.$route.params.teamInfoForRoute
    }
  },
  data () {
    return {
      teamInfo: this.teamInfoForRoute
    }
  },
  computed: {
    hasData () {
      if (this.teamInfo.city || this.teamInfo.homeCourt || this.teamInfo.capacity || this.teamInfo.address || this.teamInfo.honour || this.teamInfo.summary) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    configBasicInfo: function () {
      if (this.teamInfo.city || this.teamInfo.homeCourt || this.teamInfo.capacity || this.teamInfo.address) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "style"
</style>
